// Required JS from local files
import { dfmAlert } from "./dfm5";

// CSS
import "./login.css";

function getLapsedSubscriptionMessage(primaryContact) {
   let contactLine = primaryContact
       ? `The primary contact at your school with access to renew is: ${primaryContact}.`
       : "If you have any further questions, please contact us at <a href='mailto:support@drfrost.org'>support@drfrost.org</a>.";

   // Note - we need to use <br>s here instead of <p> tags, as the latter breaks the formatting of the message for
   //   those cases where an error parameter is specified in the URL (redirections from MS SSO).
   return "<strong>Account Status: Inactive</strong><br /><br />" +
       "Your school's subscription has lapsed. To continue using the platform, please renew your subscription.<br /><br />" +
       "<strong>How to Renew Your Subscription</strong>\<br /><br />" +
       "One teacher at your school has free full access to the platform (for up to three classes). This teacher can log in and manage the account.<br /><br />" +
       "To renew the subscription, go to <strong>Account Settings</strong> and select <strong>Subscription</strong>.<br /><br />" +
       contactLine;
}

$(document).ready(function() {
   $("#login-submit-button").click(loginUsingForm);
   $("#login-register-button").click(function(){
      window.location = 'register.php';
   });

   $(".office365-login").click(function(){
      window.location = 'azureconnect.php?action=login&url='+encodeURIComponent(typeof url !== 'undefined' ? url : window.location);
   });

   if (error) {
      var message = "";
      if (error === "1") message = "An account with that email address does not exist. Click the Register button below if you wish to create an account.";
      else if (error === "2") message = "Incorrect password.";
      else if (error === "3") message = "You need to click the link in the activation email we sent you. If you have lost this email, then <a href='reset-password.php'>click here to reset your password</a> so that another activation email will be sent.";
      else if (error === "4") message = "Your account still needs to be activated by an administrator. We'll try and do this as soon as possible.";
      else if (error === "5") message = "This account isn't yet associated with a Microsoft365 login. Login with your normal password, then link your account to Microsoft365 in Account Settings. If you do not have an account, then <a href='register.php'>Register</a>.";
      else if (error === "6") message = "Your account status prevents you from logging in.  For more information, please contact support@drfrost.org";
      else if (error === "7") message = "Please login via Google SSO.";
      else if (error === "8") message = getLapsedSubscriptionMessage(primaryContact);
      else if (error === "10") message = "Your account is now <strong>linked to a Google account</strong>. Please use the <strong>'Sign In To Google'</strong> button below.";
      else if (error === "11") message = "Your account has been approved by an administrator, but you haven't yet clicked the link in the activation email you received. If you have lost this, please contact support@drfrost.org";
      else if (error === "12") message = "Sorry. Firefly login is no longer supported.";
      else if (error === "13") message = "Your account is now <strong>linked to an Office365 account</strong>. Please use the <strong>'Sign In To Office365'</strong> button below.";
      else if (error === "21") message = "Sorry. Firefly login is no longer supported.";
      else if (error === "221") message = "Your account is not currently linked to this Office365 account. Please click <a href='settings.php'>here</a> to go to your Account Settings (logging in with your normal password and not your Office365 login), and link your account first.";

      if (message) {
         $("#dfm-home-inner-content > h1").after("<p class='error'>" + message + "</p>");
      }
   }
});

// When user clicks Google 'Sign In' button:
/**
 * Configure and render Google SSO button
 * https://developers.google.com/identity/gsi/web/guides/display-button#javascript
 */
window.onload = function () {
   if (window.google) {
      google.accounts.id.initialize({
         client_id: window.DFL?.googleClientId || "NO-GOOGLE-CLIENT-ID-AVAILABLE",
         callback: useGoogleUser
      });
      google.accounts.id.renderButton(
         document.getElementById("login-button-google"),
         { theme: "outline", size: "large" }
      );
   }
}

function useGoogleUser(googleUser) {
   let id_token = googleUser.credential;

    $.ajax({
       url: "/api/auth/logingoogle",
       type: "POST",
       contentType:"application/json",
       processData: false,
       cache: false,
       dataType: "json",
       data: JSON.stringify({"token": id_token}),
       success: function(data){
          if (url) window.location = url;
          else window.location = "dashboard.php";
       },
       error: function(j, textStatus, errorThrown) {
          let message = JSON.parse(j.responseText).message;
          if (message === "LOGIN_GOOGLE_NOUSER") {
             dfmAlert("This account isn't yet associated with a Google login. Login with your normal password, then link your account to Google in Account Settings. If you do not have an account, then <a href='register.php'>Register</a>.");
             return false;
          } else if (message === "INVALID_ADMIN_DOMAIN") {
            dfmAlert("Invalid Google account used.");
          } else if (message === "LOGIN_LAPSED_SUBSCRIPTION") {
             dfmAlert(getLapsedSubscriptionMessage(j.responseJSON?.data?.primaryContact));
          } else dfmAlert("There was a problem logging in: " + j.responseText);
       }
    });
}

function loginUsingForm() {
   let email = $("input[name=login-email]").val();
   let password = $("input[name=login-password]").val();

   if (!email || !password) {
      dfmAlert("Please ensure your email/username and password are entered");
      return false;
   }

   let formData = new FormData();
   let loginCount = 0;

   formData.append("password", password);
   formData.append("email", email);

   $.ajax({
      url: "/api/auth/login/",
      type: "POST",
      contentType: 'application/json',
      processData: false,
      cache: false,
      data: JSON.stringify({"email": email, "password": password}),
      dataType: "json",
      success: function(data){
         loginCount++;
         if(url=="stayonpage")return;
         if(url)window.location = url;
         else window.location = "dashboard.php";
      },
      error: function(j, textStatus, errorThrown) {
         if(j.responseJSON?.message === "LOGIN_INCORRECT_PASSWORD") {
            dfmAlert("The username or password is incorrect.");
         } else if(j.responseJSON?.message === "LOGIN_USER_DOESNT_EXIST") {
            dfmAlert("The username or password is incorrect.");
         } else if (j.responseJSON?.message === "LOGIN_INVALID_STATUS" && [0,11].includes(j.responseJSON?.data.status)) {
            dfmAlert("You need to click the link in the activation email we sent you. If you have lost this email, then <a href='reset-password.php'>click here to reset your password</a> so that another activation email will be sent.");
         } else if (j.responseJSON?.message === "LOGIN_INVALID_STATUS" && j.responseJSON?.data.status === 3) {
            dfmAlert("Your account still needs to be activated by an administrator. We'll try and do this as soon as possible.");
         } else if (j.responseJSON?.message === "LOGIN_LAPSED_SUBSCRIPTION") {
            dfmAlert(getLapsedSubscriptionMessage(j.responseJSON?.data?.primaryContact));
         } else if (j.responseJSON?.message === "GOOGLE_SSO_ONLY") {
            dfmAlert("Please login via Google SSO.");
         } else {
            let msg = "An error occurred when trying to login";
            msg += j.responseText ? `: <strong>${j.responseText}</strong>` : ".";
            dfmAlert(msg);
         };
      }
   });
}
